import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
  Button,
  FormText,
  Modal,
  ModalHeader,
  Spinner,
  ModalBody,
  CardFooter,
} from "reactstrap"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import Footer from "./footer"
import Lottie from "lottie-react"
import AsyncSelect from "react-select/async"
// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

// action
import {
  registerUser,
  apiError,
  registerUserConfirmation,
  getTerms,
  resetValues,
} from "../../store/actions"

//redux
import service from "../../api/supplier.service"
import { useSelector, useDispatch } from "react-redux"

import { Link } from "react-router-dom"

// import images
import profileImg from "../../assets/images/profile-img.png"

import { isValidPassword } from "../../config/validate"

import loadingAD from "../../assets/json/load-fragmented-square.json"
import "./Register.scss"

const Register = props => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  let history = useHistory()
  //meta title
  document.title = t("messageRegister:title") + " | " + t("global:title")
  const [data, setData] = useState(null)
  const [errorSelect, setErrorSelect] = useState({ exist: false, msg: "" })
  const [modal, setModal] = useState(false)
  const [providers, setproviders] = useState([])
  const [logo, setLogo] = useState()
  const { user, registrationError, loading, loadingSelect, termsConditions } =
    useSelector(state => ({
      user: state.Account.user,
      registrationError: state.Account.registrationError,
      loading: state.Account.loading,
      loadingSelect: state.Account.loadingSelect,
      termsConditions: state.Account.termsConditions,
    }))

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      provider: "",
      position: "",
      fullname: "",
      account: "",
      email: "",
      phone: "",
      password: "",
      passwordConfirmation: "",
      termsCondition: false,
    },
    validationSchema: Yup.object({
      position: Yup.string().required(
        t("registerUser:messageError") + t("registerUser:position")
      ),
      fullname: Yup.string().required(
        t("registerUser:messageError") + t("registerUser:fullname")
      ),
      account: Yup.string().required(
        t("registerUser:messageError") + t("registerUser:account")
      ),
      email: Yup.string().required(
        t("registerUser:messageError") + t("registerUser:email")
      ),
      phone: Yup.string().required(
        t("registerUser:messageError") + t("registerUser:phone")
      ),
      password: Yup.string()
        .required(t("registerUser:messageError") + t("registerUser:password"))
        .test(
          "is-password-true",
          t("registerUser:messageErrorPassword"),
          function (value) {
            return isValidPassword(value)
          }
        ),
      passwordConfirmation: Yup.string()
        .required(
          t("registerUser:messageError") +
            t("registerUser:passwordConfirmation")
        )
        .test(
          "is-password",
          t("registerUser:messageErrorPasswordConfirmation"),
          function (value) {
            return value === this.parent.password
          }
        ),
      termsCondition: Yup.bool().oneOf(
        [true],
        t("registerUser:termsConditionError") 
      ),
    }),
    onSubmit: values => {
      if (validateSelect(data)) {
        dispatch(registerUser({ ...values, provider: data }))
      }
    },
  })

  const validationConfirmation = useFormik({
    enableReinitialize: true,
    initialValues: {
      confirmation: "",
    },
    validationSchema: Yup.object({
      confirmation: Yup.string().required(
        t("registerUser:messageError") + t("registerUser:codeConfirmation")
      ),
    }),
    onSubmit: values => {
      if (validateSelect(data)) {
        dispatch(
          registerUserConfirmation(
            { ...validation.values, provider: data },
            values,
            user,
            history
          )
        )
      }
    },
  })

  useEffect(() => {
    buildStyle()
    dispatch(getTerms())
    dispatch(apiError(""))
    loadDataClient("", true)
  }, [])

  const buildStyle = () => {
    document.getElementById("body").className = "RegisterPage"
    import(
      "assets/images/" + process.env.REACT_APP_STYLE_TEMPLATE + "/logo.svg"
    ).then(setLogo)
    import(
      "assets/css/" + process.env.REACT_APP_STYLE_TEMPLATE + "/registerUser.css"
    )
  }
  const loadDataClient = async (inputValue, selected = false) => {
    let json = {
      filter: inputValue,
      society: "BO81",
      length: 20,
    }
    if (selected || inputValue) {
      return await service.getProviders(json)
    }
  }

  const changeClient = value => {
    setData(value)
    validateSelect(value)
  }

  const onBack = () => {
    dispatch(resetValues())
    history.push("/login")
  }

  const toggle = () => setModal(!modal)

  const validateSelect = data => {
    if (data) {
      if (data.userCount.count < data.userLimit) {
        setErrorSelect({ exist: false, msg: t("registerUser:providerCount") })
        return true
      } else {
        setErrorSelect({ exist: true, msg: t("registerUser:providerCount") })
        return false
      }
    } else {
      setErrorSelect({
        exist: true,
        msg: t("registerUser:messageError") + t("registerUser:provider"),
      })
      return false
    }
  }

  const renderConfirmation = () => {
    return (
      <Form
        className="form-horizontal"
        onSubmit={e => {
          e.preventDefault()
          validationConfirmation.handleSubmit()
          return false
        }}
      >
        {user && user ? (
          <Alert color="success">Register User Successfully</Alert>
        ) : null}

        {registrationError && registrationError ? (
          <Alert color="danger">{registrationError}</Alert>
        ) : null}
        <div className="mb-3">
          <Label className="form-label">
            {t("registerUser:codeConfirmation")}
          </Label>
          <Input
            id="confirmation"
            name="confirmation"
            className="form-control"
            type="text"
            onChange={validationConfirmation.handleChange}
            onBlur={validationConfirmation.handleBlur}
            value={validationConfirmation.values.confirmation || ""}
            invalid={
              validationConfirmation.touched.confirmation &&
              validationConfirmation.errors.confirmation
                ? true
                : false
            }
          />
          {validationConfirmation.touched.confirmation &&
          validationConfirmation.errors.confirmation ? (
            <FormFeedback type="invalid">
              {validationConfirmation.errors.confirmation}
            </FormFeedback>
          ) : null}
        </div>
        <div className="mt-4">
          <Button className="mr-4" color="primary" onClick={onBack}>
            {t("registerUser:back")}
          </Button>{" "}
          <Button className="mr-4" color="primary" type="submit">
            {t("registerUser:sendConfirmation")}
          </Button>
        </div>
        {""}
      </Form>
    )
  }
  const onChangeSupplier = (value, action) => {
    changeClient(value)
    if (action.action === "clear") {
      loadDataClient("", true)
    }
  }
  const loadingOptionSupplier = async (filter, callback) => {
    if (filter.length >= 3) {
      const data = await loadDataClient(filter)

      const s = data?.data?.map(item => {
        return {
          ...item,
          value: item.code,
          label: item.name + " | " + item.nit,
        }
      })
      callback(s)
    }
  }
  return loading ? (
    <div>
      <Lottie animationData={loadingAD} />
    </div>
  ) : (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={8}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {t("messageRegister:title")}
                        </h5>
                        <p>{t("messageRegister:subTitle")}</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-info">
                          <img
                            src={logo?.default}
                            alt=""
                            className="rounded-circle"
                            height="64"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {!user ? (
                      <Form
                        className="form-horizontal"
                        onSubmit={e => {
                          e.preventDefault()
                          validation.handleSubmit()
                          validateSelect(data)
                          return false
                        }}
                      >
                        {user && user ? (
                          <Alert color="success">
                            Register User Successfully
                          </Alert>
                        ) : null}

                        {registrationError && registrationError ? (
                          <Alert color="danger">{registrationError}</Alert>
                        ) : null}
                        <Row>
                          <Col md={8}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("registerUser:provider")}{" "}
                                {loadingSelect ? (
                                  <Spinner color="primary" size="sm" />
                                ) : null}
                              </Label>
                              <AsyncSelect
                                loadOptions={loadingOptionSupplier}
                                maxMenuHeight={150}
                                cacheOptions
                                className="small-font text-uppercase"
                                isDisabled={loading}
                                placeholder={t("monitor:supplierFind")}
                                name="supplier"
                                isClearable
                                // isLoading={loadingSupplier}
                                onChange={(value, action) => {
                                  onChangeSupplier(value, action)
                                }}
                              />

                              {errorSelect.exist ? (
                                <FormText size="xs" className="p-0 color-error">
                                  {errorSelect.msg}
                                </FormText>
                              ) : null}
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("registerUser:position")}
                              </Label>
                              <Input
                                id="position"
                                name="position"
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.position || ""}
                                invalid={
                                  validation.touched.position &&
                                  validation.errors.position
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.position &&
                              validation.errors.position ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.position}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("registerUser:fullname")}
                              </Label>
                              <Input
                                id="fullname"
                                name="fullname"
                                className="form-control"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.fullname || ""}
                                invalid={
                                  validation.touched.fullname &&
                                  validation.errors.fullname
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.fullname &&
                              validation.errors.fullname ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.fullname}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("registerUser:account")}
                              </Label>
                              <Input
                                name="account"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.account || ""}
                                invalid={
                                  validation.touched.account &&
                                  validation.errors.account
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.account &&
                              validation.errors.account ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.account}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("registerUser:email")}
                              </Label>
                              <Input
                                id="email"
                                name="email"
                                className="form-control"
                                type="email"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                  validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.email &&
                              validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.email}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("registerUser:phone")}
                              </Label>
                              <Input
                                name="phone"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.phone || ""}
                                invalid={
                                  validation.touched.phone &&
                                  validation.errors.phone
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.phone &&
                              validation.errors.phone ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.phone}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <div>
                          <Label className="form-label label-notification">
                            {t("messageRegister:msmPassword")}
                          </Label>
                        </div>
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("registerUser:password")}
                              </Label>
                              <Input
                                name="password"
                                type="password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.password || ""}
                                invalid={
                                  validation.touched.password &&
                                  validation.errors.password
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.password &&
                              validation.errors.password ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.password}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("registerUser:passwordConfirmation")}
                              </Label>
                              <Input
                                name="passwordConfirmation"
                                type="password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.passwordConfirmation || ""
                                }
                                invalid={
                                  validation.touched.passwordConfirmation &&
                                  validation.errors.passwordConfirmation
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.passwordConfirmation &&
                              validation.errors.passwordConfirmation ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.passwordConfirmation}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <div className="mb-3">
                          <Input
                            name="termsCondition"
                            type="checkbox"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            defaultChecked={
                              validation.values.termsCondition || false
                            }
                            invalid={
                              validation.touched.termsCondition &&
                              validation.errors.termsCondition
                                ? true
                                : false
                            }
                          />
                          {"  "}
                          <Label check>
                            <Link
                              to="#"
                              className="text-primary"
                              onClick={toggle}
                            >
                              {t("registerUser:termsCondition")}
                            </Link>
                          </Label>
                          {validation.touched.termsCondition &&
                          validation.errors.termsCondition ? (
                            <FormFeedback type="invalid">
                              {validation.errors.termsCondition}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <Modal isOpen={modal} toggle={toggle} centered>
                          <ModalHeader toggle={toggle}>
                            {termsConditions
                              ? termsConditions.name
                              : t("registerUser:termsCondition")}
                          </ModalHeader>
                          <ModalBody>
                            {termsConditions ? termsConditions.value : ""}
                          </ModalBody>
                        </Modal>
                        <div className="mt-4 mb-4 text-end">
                          <Button
                            className="mr-4"
                            color="primary"
                            onClick={onBack}
                          >
                            {t("registerUser:back")}
                          </Button>{" "}
                          <Button
                            className="mr-4"
                            color="primary"
                            disabled={!user}
                          >
                            <i className="mdi mdi-send-circle-outline me-1" />
                            {t("registerUser:sendConfirmation")}
                          </Button>{" "}
                          <Button
                            className="mr-2"
                            color="primary"
                            type="submit"
                          >
                            <i className="mdi mdi-content-save me-1" />
                            {t("registerUser:save")}
                          </Button>
                        </div>
                      </Form>
                    ) : (
                      renderConfirmation()
                    )}
                  </div>
                </CardBody>
                <CardFooter>
                  <div className=" text-center">
                    <p>
                      {t("messageRegister:alreadyRegistered")}{" "}
                      <Link
                        to="/login"
                        className="font-weight-medium text-primary"
                      >
                        {" "}
                        {t("authentication:login")}
                      </Link>{" "}
                    </p>
                    <Footer />
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Register
